// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nw-1";
export var stateContainer = "_nw-0";